<template>
  <v-card>
    <v-card-text>
      <v-textarea v-model="comment" label="Leave a comment" />
      <v-file-input
        v-model="files"
        multiple
        @update:model-value="updateUrls"
      ></v-file-input>
      <v-row v-if="files" class="d-flex">
        <v-col
          v-for="file in files"
          :key="file.name"
          class="align-self-end"
          cols="4"
        >
          <v-img
            v-if="file.type.startsWith('image/') && urls.has(file.name)"
            max-height="300px"
            :src="urls.get(file.name) || ''"
          />
          <div>
            <b>{{ file.name }}</b
            >,
            <span v-if="file.type" class="text-no-wrap">{{ file.type }}, </span>
            <span>{{ file.size }} bytes</span>
          </div>
        </v-col></v-row
      >
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="open"
        color="warning"
        type="submit"
        variant="outlined"
        @click="send('close')"
        >Close issue</v-btn
      >
      <v-btn
        v-if="closed"
        color="warning"
        type="submit"
        variant="outlined"
        @click="send('reopen')"
        >Reopen issue</v-btn
      >
      <v-btn
        color="primary"
        :disabled="comment === ''"
        variant="flat"
        @click="send('comment')"
        >Comment</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script setup lang="ts">
import { type Ref, ref } from "vue";
defineProps<{
  open: boolean;
  closed: boolean;
}>();
const emit =
  defineEmits<
    (e: "close" | "reopen" | "comment", comment: string, files: File[]) => void
  >();

const comment = ref("");
const files: Ref<File[]> = ref([]);
const urls = ref(new Map<string, string>());

function updateUrls() {
  for (const file of files.value) {
    if (!urls.value.has(file.name)) {
      console.log(file.name);
      urls.value.set(file.name, URL.createObjectURL(file));
    }
  }
  for (const [name, _] of urls.value) {
    if (!files.value.some((file) => file.name === name)) {
      urls.value.delete(name);
    }
  }
}

function send(type: "close" | "reopen" | "comment") {
  if (comment.value || type !== "comment" || files.value.length > 0) {
    emit(type, comment.value, files.value);
    comment.value = "";
    files.value = [];
  }
}
</script>
